import React from "react";
import { useTranslation } from "react-i18next";
import BannerOne from "../components/BannerOne";
import FeaturedOne from "../components/FeaturedOne";
import Problems from "../components/Problems";
import ServiceOne from "../components/ServiceOne";
import Faq from "../components/Faq";
import Testimonial from "../components/Testimonial";
import BrandSectionOne from "../components/BrandSectionOne";
import BecomeSellerTwo from "../components/BecomeSellerTwo";
import { useTheme } from "../components/ThemeProvider";
import Preloader from "../helper/Preloader";
import SellingOne from "../components/SellingOne";

const HomePage = ({ openModal, isModalOpen, handleOpenModal }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();

  return (
    <section className="change-gradient">
      {/* Preloader */}
      <Preloader />

      <BannerOne
        setOpenGetDemoModal={() => openModal("getDemo")}
        setOpenCalendlyModal={() => openModal("calendly")}
      />

      <BrandSectionOne />

      <div id="about">
        <FeaturedOne
          title={t("aboutSection.title")}
          descriptionLine1={t("aboutSection.desc1")}
          descriptionLine2={t("aboutSection.desc2")}
          descriptionLine3={t("aboutSection.desc3")}
          direction="text-left"
          img={`/assets/images/thumbs/aboutUs_img_${isDarkMode ? "light" : "dark"}.webp`}
          withoutPadding
          isGradient
          isContainer={true}
        />
      </div>

      <Problems direction="text-right" />

      <ServiceOne isGradient/>

      <Faq />
    </section>
  );
};

export default HomePage;
